import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-vehicle-segment-options-detail',
  templateUrl: './vehicle-segment-options-detail.component.html',
  styleUrls: ['./vehicle-segment-options-detail.component.css']
})
export class VehicleSegmentOptionsDetailComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
